import { render, staticRenderFns } from "./genre-hero.vue?vue&type=template&id=ecd23592&scoped=true&"
import script from "./genre-hero.vue?vue&type=script&lang=js&"
export * from "./genre-hero.vue?vue&type=script&lang=js&"
import style0 from "./genre-hero.vue?vue&type=style&index=0&id=ecd23592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd23592",
  null
  
)

export default component.exports